
import React from "react";
import { ServiceType } from "@/context/LeadContext";

interface ServiceBadgeProps {
  service: ServiceType;
}

const ServiceBadge: React.FC<ServiceBadgeProps> = ({ service }) => {
  const getServiceLabel = () => {
    switch (service) {
      case "εξοικονομώ":
        return "Εξοικονομώ";
      case "αντλίεςΘερμότητας":
        return "Αντλίες Θερμότητας";
      case "φωτοβολταϊκά":
        return "Φωτοβολταϊκά";
      case "κλιματιστικά":
        return "Κλιματιστικά";
      case "φυσικόΑέριο":
        return "Φυσικό Αέριο";
      case "ηλιακά":
        return "Ηλιακά";
      case "ανακαινίζωΕνεργειακά":
        return "Ανακαινίζω - Ενεργειακά συστήματα";
      case "ανακαινίζωΠλήρηςΑνακαίνιση":
        return "Ανακαινίζω - Πλήρης ανακαίνιση";
      case "άλλο":
        return "Άλλο";
      default:
        return "Άγνωστο";
    }
  };

  const getServiceColor = () => {
    switch (service) {
      case "εξοικονομώ":
        return "bg-green-100 text-green-800";
      case "αντλίεςΘερμότητας":
        return "bg-blue-100 text-blue-800";
      case "φωτοβολταϊκά":
        return "bg-yellow-100 text-yellow-800";
      case "κλιματιστικά":
        return "bg-purple-100 text-purple-800";
      case "φυσικόΑέριο":
        return "bg-red-100 text-red-800";
      case "ηλιακά":
        return "bg-orange-100 text-orange-800";
      case "ανακαινίζωΕνεργειακά":
        return "bg-sky-100 text-sky-800";
      case "ανακαινίζωΠλήρηςΑνακαίνιση":
        return "bg-rose-100 text-rose-800";
      case "άλλο":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getServiceColor()}`}>
      {getServiceLabel()}
    </span>
  );
};

export default ServiceBadge;
